export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popover-item.vue?vue&type=template&id=9a8ca2ba&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/popover/popover-item.vue?vue&type=template&id=9a8ca2ba&
// module id = 1189
// module chunks = 0